// Old single-swatch popup code removed — replaced by multi-swatch drawer (see bottom of file)

if (document.querySelector('.product-info__block-item quantity-selector') && document.querySelector('.add-to-cart-container button')) {
    const addToCartButton = document.querySelector('.add-to-cart-container button');
    const quantitySelector = document.querySelector('.product-info__block-item quantity-selector');
    addToCartButton.insertAdjacentElement('afterend', quantitySelector);
}

document.addEventListener('variant:change', function(evt) {
    if (document.querySelector('[data-custom-variant-title]')) {
        const variantPublicTitle = evt.detail.variant.public_title;
        const variantTitleElement = document.querySelectorAll('[data-custom-variant-title]');
        variantTitleElement.forEach((variantTitle) => {
            variantTitle.textContent = variantPublicTitle;
        });
    }
});

// =============================================================================
// VARIANT IMAGE FILTERING
// =============================================================================
// Stressless products: color-based filtering (filenames are {color_slug}_{suffix}.jpg)
// Other products: barcode-based filtering (filenames start with {barcode}_)
// Images that don't match ANY known prefix are universal (shown for all).
//
// IMPORTANT: The Prestige theme's ProductGallery component has its own
// variant:change handler (on the form element) that calls carousel.filter([])
// which UNHIDES all images. Our handler fires after (on document, bubble phase)
// but we use queueMicrotask to guarantee our filtering is the absolute last
// thing to run before the browser paints.

function handleize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

// Find the index of an option by name, handling both string arrays and object arrays
// product.js returns ["Size", "Color"], but some theme contexts may return [{name:"Size"}, ...]
function findOptionIndex(options, name) {
    if (!options) return -1;
    for (var i = 0; i < options.length; i++) {
        var opt = options[i];
        var optName = typeof opt === 'string' ? opt : (opt.name || opt.label || '');
        if (optName === name) return i;
    }
    return -1;
}

document.addEventListener('variant:change', function(evt) {
    var variant = evt.detail.variant;
    var product = evt.detail.product;

    if (!product || !variant) return;

    var colorIndex = findOptionIndex(product.options, 'Color');
    var productType = product.type || product.productType || '';

    var selectedPrefixes, allPrefixes;

    if (colorIndex !== -1 && product.vendor === 'Stressless') {
        // COLOR-SLUG filtering — Stressless's filenames are {color-slug}_*.jpg.
        // Gated to Stressless because other vendors (Four Hands rugs etc.) also
        // have a "Color" option but use SKU-prefix filenames; without this gate
        // they'd fall here, find zero matches, and "universal-fallback" every
        // image (this was the rug-PDP bug).
        var selectedSlug = handleize(variant.options[colorIndex]);
        selectedPrefixes = [selectedSlug + '_'];

        var seen = {};
        allPrefixes = [];
        product.variants.forEach(function(v) {
            var color = v.options[colorIndex];
            if (color && !seen[color]) {
                seen[color] = true;
                allPrefixes.push(handleize(color) + '_');
            }
        });
    } else {
        // BARCODE-PREFIX filtering — filenames start with {variant.barcode}_.
        var barcodeMap = window.variantBarcodes || {};
        var prefixFor = function(v) {
            return (barcodeMap[v.id] || v.barcode || '').toLowerCase() + '_';
        };

        allPrefixes = product.variants
            .map(prefixFor)
            .filter(function(p) { return p.length > 1; });

        // Size-as-dimension products (rugs, bedding): Size is just dimensions,
        // not visual — when a product has a Color option and a non-visual Size
        // axis, group all same-color sibling barcodes so switching Size keeps
        // the same image set visible (same intent as Stressless Size, which
        // never affected filtering). Match rugs + bedding productTypes.
        // Throw Pillows also qualify: a pillow's Color is visual but its other
        // axis (Insert Type / Size) is not — group same-color barcodes so
        // switching insert/size keeps the colorway's photos shown (LR Home).
        if (colorIndex !== -1 && /\b(rugs?|blankets?|sheets?|sheet sets?|duvet (covers?|sets?)|comforters?|pillowcases?|throw pillows?|(mattress )?protectors?)\b/i.test(productType)) {
            var selectedColor = variant.options[colorIndex];
            selectedPrefixes = product.variants
                .filter(function(v) { return v.options[colorIndex] === selectedColor; })
                .map(prefixFor)
                .filter(function(p) { return p.length > 1; });
        } else {
            var selectedPrefix = prefixFor(variant);
            selectedPrefixes = selectedPrefix.length > 1 ? [selectedPrefix] : [];
        }
    }

    // Defensive bail: if we lack enough data to filter meaningfully, leave
    // the gallery as the server (or Prestige's native variant_image filter)
    // rendered it. Calling carousel.filter([]) with no prefixes UNHIDES every
    // image — actively worse than doing nothing.
    if (allPrefixes.length === 0 || selectedPrefixes.length === 0) return;

    var gallery = document.querySelector('product-gallery');
    if (!gallery) return;

    var carousel = gallery.querySelector('scroll-carousel');
    var mediaElements = gallery.querySelectorAll('.product-gallery__media');
    var filteredIndexes = [];

    mediaElements.forEach(function(media, index) {
        var img = media.querySelector('img');
        if (!img) return; // Non-image media — treat as universal

        var src = img.dataset.originalSrc || img.src || img.currentSrc || '';
        var filename = src.split('/').pop().split('?')[0].toLowerCase();

        var matchesSelected = selectedPrefixes.some(function(p) {
            return filename.startsWith(p);
        });

        var matchesAny = allPrefixes.some(function(prefix) {
            return filename.startsWith(prefix);
        });

        var isUniversal = !matchesAny;

        if (!matchesSelected && !isUniversal) {
            filteredIndexes.push(index);
        }
    });

    // Never hide EVERYTHING. When the selected variant's prefix matches no
    // image at all (e.g. the synthetic page-load event lacks productType /
    // per-variant options, so colorway grouping can't run and a non-rep
    // variant — deep link or a Poly/Feather default whose colorway images
    // carry a sibling's prefix — matches zero files), hiding every image
    // leaves a blank gallery. Showing the full set and letting the next real
    // variant:change filter properly is strictly better.
    var imageMediaCount = 0;
    mediaElements.forEach(function(media) { if (media.querySelector('img')) imageMediaCount++; });
    if (imageMediaCount > 0 && filteredIndexes.length >= imageMediaCount) return;

    // Use queueMicrotask to ensure our filtering runs AFTER the Prestige theme's
    // ProductGallery.onVariantChange handler, which calls carousel.filter([]) and
    // unhides all images. Microtasks run after all synchronous event handlers
    // complete but before the browser paints — no visual flash.
    queueMicrotask(function() {
        // Apply filtering to carousel cells
        if (carousel && typeof carousel.filter === 'function') {
            carousel.filter(filteredIndexes);
        } else {
            // Fallback: directly toggle hidden attributes
            mediaElements.forEach(function(media, index) {
                media.toggleAttribute('hidden', filteredIndexes.indexOf(index) !== -1);
            });
        }

        // Filter thumbnails
        var thumbnails = gallery.querySelectorAll('.product-gallery__thumbnail');
        thumbnails.forEach(function(thumb, index) {
            thumb.toggleAttribute('hidden', filteredIndexes.indexOf(index) !== -1);
        });

        // Filter dot indicators (mobile)
        var dotsContainer = gallery.querySelector('carousel-navigation.page-dots');
        if (!dotsContainer && gallery.parentElement) {
            dotsContainer = gallery.parentElement.querySelector('carousel-navigation.page-dots');
        }
        if (dotsContainer) {
            var dots = dotsContainer.querySelectorAll('button');
            dots.forEach(function(dot, index) {
                dot.toggleAttribute('hidden', filteredIndexes.indexOf(index) !== -1);
            });
        }

        // Clean up any inline display styles from old theme.js filtering
        gallery.querySelectorAll('.product-gallery__media[style*="display"]').forEach(function(el) {
            el.style.removeProperty('display');
        });
        gallery.querySelectorAll('.product-gallery__thumbnail[style*="display"]').forEach(function(el) {
            el.style.removeProperty('display');
        });
    });
});

// =============================================================================
// INITIAL PAGE-LOAD IMAGE FILTER
// =============================================================================
// The variant:change handler above is only fired by the variant-picker when
// the customer interacts. On initial page load (especially with a ?variant=
// URL), no event fires — so the gallery shows whichever image happens to
// come first in product.media regardless of the selected variant.
//
// This dispatches a synthetic variant:change event built from the DOM, so
// the existing filter logic runs once at load and the gallery starts on the
// correct variant's images.
document.addEventListener('DOMContentLoaded', function () {
    var picker = document.querySelector('variant-picker[handle]');
    if (!picker) return;   // no variant picker → nothing to filter

    var form = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var variantId = form ? parseInt(form.value, 10) : NaN;
    if (!variantId) return;

    var barcodeMap = window.variantBarcodes || {};

    // Reconstruct option metadata from the picker DOM so the existing handler
    // can decide between color-based filtering (Stressless) and barcode-based
    // (Four Hands). data-option-name is lowercase from Shopify; capitalize to
    // match the handler's `findOptionIndex(product.options, 'Color')` check.
    var fieldsets = document.querySelectorAll('fieldset.variant-picker__option[data-option-name]');
    var optionNames = [];
    var selectedValues = [];
    fieldsets.forEach(function (fs) {
        var n = fs.dataset.optionName || '';
        optionNames.push(n.charAt(0).toUpperCase() + n.slice(1));
        var chk = fs.querySelector('input[type="radio"]:checked');
        selectedValues.push(chk ? chk.value : '');
    });

    var syntheticVariants = Object.keys(barcodeMap).map(function (id) {
        return { id: parseInt(id, 10), barcode: barcodeMap[id], options: [] };
    });

    document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
            variant: { id: variantId, barcode: barcodeMap[variantId] || '', options: selectedValues },
            product: { options: optionNames, variants: syntheticVariants }
        }
    }));
});

// =============================================================================
// STRESSLESS FINISH IMAGE SWAP
// =============================================================================
// Swaps product gallery images to show the selected wood/alu finish by
// rewriting CDN URLs. Uses color-slug keys from stressless_image_map metafield.

(function stresslessFinishInit() {
    var CDN_BASE = 'https://d3kpm8kazby4td.cloudfront.net/';
    var DEBUG = true;

    function log() {
        if (DEBUG) console.log.apply(console, ['[finish]'].concat(Array.prototype.slice.call(arguments)));
    }

    function getFinishSelector() {
        return document.querySelector('.stressless-finish-selector');
    }

    // --- State: track selected finish in JS (radio :checked is unreliable in
    //     Shopify sandbox/editor, so we never rely on it) ---
    var _selectedWood = null;  // e.g. "Brown"
    var _selectedAlu = null;   // e.g. "Matte Black" (null for Classic)

    // Inject hidden inputs into the product form for cart line properties
    var _finishInput = null;
    var _orderPidInput = null;

    function ensureFormInputs() {
        if (_finishInput && _finishInput.isConnected) return;

        var form = document.querySelector('form[is="product-form"]');
        if (!form) {
            log('product form not found');
            return;
        }

        var selector = getFinishSelector();
        if (!selector) return;

        var propName = selector.dataset.finishProperty || 'Wood Finish';
        var defaultVal = selector.dataset.defaultValue || '';

        _finishInput = document.createElement('input');
        _finishInput.type = 'hidden';
        _finishInput.name = 'properties[' + propName + ']';
        _finishInput.value = defaultVal;
        form.appendChild(_finishInput);

        _orderPidInput = document.createElement('input');
        _orderPidInput.type = 'hidden';
        _orderPidInput.name = 'properties[_Order PID]';
        _orderPidInput.value = '';
        form.appendChild(_orderPidInput);

        log('injected hidden inputs into form — property:', propName, 'default:', defaultVal);
    }

    // Extract color slug from a Shopify-hosted image filename
    // Shopify appends a UUID: "paloma-fog_front_f65020b1-921f-4605-abb6-ed3828ad3ddb.jpg"
    function extractColorSlug(src) {
        if (!src) return null;
        var filename = src.split('/').pop().split('?')[0];
        var match = filename.match(/^([a-z0-9-]+)_(front|01|02|03)[_.]/);
        return match ? match[1] : null;
    }

    // Extract the image suffix (front, 01, 02, 03) from filename
    function extractSuffix(src) {
        if (!src) return 'front';
        var filename = src.split('/').pop().split('?')[0];
        // Match known suffixes (handles UUID-appended filenames)
        var match = filename.match(/_(front|01|02|03)[_.]/);
        if (match) return match[1];
        // Fallback for non-Stressless images
        var match2 = filename.match(/_(\w+)\.jpg$/);
        if (!match2) return 'front';
        var suffix = match2[1];
        if (/^\d+x$/.test(suffix)) return 'front';
        return suffix;
    }

    function buildCdnUrl(pid, woodCode, aluCode, suffix) {
        var newPid;
        var config = window.stresslessConfig || {};
        if (config.base_type === 'Disc') {
            // Disc-base PID: {material}{fabric}{wood}{base}. base_wood means the
            // base takes the same wood as the arms (code repeated); otherwise
            // the trailing 2 digits are a fixed finish (e.g. metal).
            var discTail = config.base_wood ? woodCode : pid.slice(-2);
            newPid = pid.slice(0, -4) + woodCode + discTail;
        } else if (pid.length <= 14) {
            newPid = pid.slice(0, -2) + woodCode;
        } else {
            newPid = pid.slice(0, -4) + aluCode + woodCode;
        }
        return CDN_BASE + newPid + '_2400x2400_' + suffix + '.jpg';
    }

    var currentVariantId = null;

    function updateOrderPid(woodCode, aluCode) {
        if (!_orderPidInput) return;

        var barcodeMap = window.variantBarcodes || {};
        var variantId = currentVariantId;
        if (!variantId) {
            variantId = new URLSearchParams(window.location.search).get('variant');
        }

        var barcode = variantId ? barcodeMap[variantId] : null;
        if (!barcode) { _orderPidInput.value = ''; return; }

        var config = window.stresslessConfig || {};
        if (config.base_type === 'Classic') {
            _orderPidInput.value = barcode.slice(0, -2) + woodCode;
        } else if (config.base_type === 'Disc') {
            _orderPidInput.value = barcode.slice(0, -4) + woodCode +
                (config.base_wood ? woodCode : barcode.slice(-2));
        } else {
            _orderPidInput.value = barcode.slice(0, -4) + aluCode + woodCode;
        }
    }

    function swapFinishImages(woodCode, aluCode) {
        var imageMap = window.stresslessImageMap || {};
        if (Object.keys(imageMap).length === 0) {
            log('imageMap is empty, skipping swap');
            return;
        }

        // Skip CDN swap when finish matches defaults — Shopify images
        // already show the default finish with processed backgrounds.
        var config = window.stresslessConfig || {};
        var codes = window.stresslessFinishCodes || {};
        var defaultWoodCode = (codes.wood || {})[config.default_wood || 'Brown'] || '03';
        var defaultAluCode = (codes.alu || {})[config.default_alu || 'Matte Black'] || '45';
        if (woodCode === defaultWoodCode && aluCode === defaultAluCode) {
            log('finish matches defaults, restoring Shopify images');
            var gallery = document.querySelector('product-gallery');
            if (gallery) {
                gallery.querySelectorAll('.product-gallery__media img, .product-gallery__thumbnail img').forEach(function(img) {
                    if (img.dataset.originalSrc) {
                        img.src = img.dataset.originalSrc;
                        if (img.srcset) img.srcset = '';
                    }
                });
            }
            updateOrderPid(woodCode, aluCode);
            return;
        }

        var gallery = document.querySelector('product-gallery');
        if (!gallery) {
            log('no product-gallery element found');
            return;
        }

        var imgs = gallery.querySelectorAll('.product-gallery__media img, .product-gallery__thumbnail img');
        log('swapping', imgs.length, 'images → wood=' + woodCode, 'alu=' + aluCode);

        var swapped = 0;
        imgs.forEach(function(img) {
            if (!img.dataset.originalSrc) {
                img.dataset.originalSrc = img.src;
            }

            var colorSlug = extractColorSlug(img.dataset.originalSrc);
            if (!colorSlug) return;

            var cdnPid = imageMap[colorSlug];
            if (!cdnPid) return;

            var suffix = extractSuffix(img.dataset.originalSrc);
            var newUrl = buildCdnUrl(cdnPid, woodCode, aluCode, suffix);

            img.src = newUrl;
            if (img.srcset) {
                img.srcset = newUrl + ' 2400w';
            }
            swapped++;

            img.onerror = function() {
                log('CDN error, restoring original for', colorSlug);
                img.src = img.dataset.originalSrc;
                img.onerror = null;
            };
        });

        log('swapped', swapped, '/', imgs.length);
        updateOrderPid(woodCode, aluCode);
    }

    // Look up finish codes from JS state (never uses :checked)
    function getSelectedCodes() {
        if (!_selectedWood) return null;
        var codes = window.stresslessFinishCodes || {};
        var woodCode = codes.wood[_selectedWood];
        if (!woodCode) return null;
        var aluCode = _selectedAlu ? (codes.alu[_selectedAlu] || '45') : '45';
        return { wood: woodCode, alu: aluCode };
    }

    // Set finish state from a wood name and optional alu name.
    // Updates ALL .stressless-finish-selector instances on the page for robustness.
    function setFinish(woodName, aluName) {
        _selectedWood = woodName;
        _selectedAlu = aluName || null;

        var displayVal = aluName ? (aluName + ' / ' + woodName) : woodName;

        // Update ALL finish selector instances (defensive — handles multiple if present)
        var selectors = document.querySelectorAll('.stressless-finish-selector');
        if (selectors.length === 0) {
            log('setFinish: no selectors found on page');
        }

        selectors.forEach(function(selector) {
            // Update legend display text
            var valueEl = selector.querySelector('.stressless-finish-selector__value');
            if (valueEl) {
                valueEl.textContent = displayVal;
            }

            // Update selected visual state — use both class toggle AND inline outline
            var allSwatches = selector.querySelectorAll('.stressless-finish-selector__swatch');
            allSwatches.forEach(function(s) {
                s.classList.remove('stressless-finish-selector__swatch--selected');
                var img = s.querySelector('.stressless-finish-selector__swatch-image, .stressless-finish-selector__swatch-combo');
                if (img) {
                    img.style.outline = '';
                    img.style.outlineOffset = '';
                }
            });

            var target = selector.querySelector('.stressless-finish-selector__swatch[data-finish-value="' + displayVal + '"]');
            if (target) {
                target.classList.add('stressless-finish-selector__swatch--selected');
                var targetImg = target.querySelector('.stressless-finish-selector__swatch-image, .stressless-finish-selector__swatch-combo');
                if (targetImg) {
                    targetImg.style.outline = '2px solid #24211f';
                    targetImg.style.outlineOffset = '2px';
                }
            }

            log('setFinish →', displayVal,
                'swatches:', allSwatches.length,
                'target:', target ? 'found' : 'NOT FOUND',
                'valueEl:', valueEl ? '"' + valueEl.textContent + '"' : 'N/A');
        });

        // Update hidden form input
        ensureFormInputs();
        if (_finishInput) {
            _finishInput.value = displayVal;
        }

        // Swap images
        var selected = getSelectedCodes();
        if (selected) swapFinishImages(selected.wood, selected.alu);
    }

    // Listen for finish swatch changes via radio change events.
    // Using 'change' is more reliable than 'click' delegation because the
    // browser handles label→radio activation natively — no need for
    // preventDefault or manual input.checked which can cause subtle issues.
    document.addEventListener('change', function(e) {
        var input = e.target;
        if (input.type !== 'radio') return;

        var label = input.closest('.stressless-finish-selector__swatch');
        if (!label) return;

        var selector = input.closest('.stressless-finish-selector');
        if (!selector) return;

        var baseType = selector.dataset.baseType;

        log('swatch change — baseType:', baseType, 'input.value:', input.value,
            'woodName:', input.dataset.woodName, 'aluName:', input.dataset.aluName);

        if (baseType === 'Classic' || baseType === 'Disc') {
            setFinish(input.value, null);
        } else {
            setFinish(input.dataset.woodName, input.dataset.aluName);
        }
    });

    // On variant change, re-apply the active finish swap.
    // Uses setTimeout to run AFTER the filtering microtask completes
    // and the carousel has settled with the correct visible images.
    document.addEventListener('variant:change', function(evt) {
        if (evt.detail && evt.detail.variant) {
            currentVariantId = evt.detail.variant.id;
        }
        var selected = getSelectedCodes();
        if (!selected) return;
        setTimeout(function() {
            swapFinishImages(selected.wood, selected.alu);
        }, 150);
    });

    // Initialize: read defaults from config (images already have Brown finish baked in)
    document.addEventListener('DOMContentLoaded', function() {
        var selector = getFinishSelector();
        if (!selector) return;

        var config = window.stresslessConfig || {};
        log('init — imageMap keys:', Object.keys(window.stresslessImageMap || {}).length,
            'config:', JSON.stringify(config));

        ensureFormInputs();

        // Set initial state from config defaults (no :checked dependency)
        _selectedWood = config.default_wood || 'Brown';
        _selectedAlu = config.default_alu || null;
        log('initial state: wood=' + _selectedWood, 'alu=' + _selectedAlu);
    });
})();

// =============================================================================
// CANADEL FINISH SELECTOR
// =============================================================================
// Canadel's 10 curated wood/painted finishes are price-neutral, so they are NOT
// Shopify variants (fabrics are the variant axis). This block mirrors the
// Stressless finish selector: a radio swatch set that (a) carries the chosen
// finish into the cart as a `properties[Finish]` line-item property and (b)
// swaps the product photo per finish using window.canadelImageMap, keyed
// { finishCode: { variantId: renderUrl } }. Self-contained; gated on the
// presence of .canadel-finish-selector so it no-ops on every other product.

(function canadelFinishInit() {
    var DEBUG = false;
    function log() { if (DEBUG) console.log.apply(console, ['[canadel-finish]'].concat([].slice.call(arguments))); }

    function getSelector() { return document.querySelector('.canadel-finish-selector'); }

    var _finishCode = null;     // e.g. "19"
    var _finishName = null;     // e.g. "Cognac Washed"
    var _variantId = null;      // current variant (numeric id as string)
    var _finishInput = null;

    function ensureFormInput() {
        if (_finishInput && _finishInput.isConnected) return;
        var form = document.querySelector('form[is="product-form"]');
        var selector = getSelector();
        if (!form || !selector) return;
        var propName = selector.dataset.finishProperty || 'Finish';
        _finishInput = document.createElement('input');
        _finishInput.type = 'hidden';
        _finishInput.name = 'properties[' + propName + ']';
        _finishInput.value = selector.dataset.defaultValue || '';
        form.appendChild(_finishInput);
        log('injected properties[' + propName + '] =', _finishInput.value);
    }

    function currentVariantId() {
        if (_variantId) return _variantId;
        var u = new URLSearchParams(window.location.search).get('variant');
        return u || null;
    }

    // Swap the main gallery image(s) to the render for (finish × current variant).
    function swapImage() {
        var map = window.canadelImageMap || {};
        var cfg = window.canadelConfig || {};
        var gallery = document.querySelector('product-gallery');
        if (!gallery) return;
        var imgs = gallery.querySelectorAll('.product-gallery__media img, .product-gallery__thumbnail img');

        // default finish → restore the Shopify-hosted variant images
        if (!_finishCode || _finishCode === (cfg.default_finish || '')) {
            imgs.forEach(function(img) {
                if (img.dataset.canadelOrig) { img.src = img.dataset.canadelOrig; img.srcset = ''; }
            });
            return;
        }
        var byVariant = map[_finishCode] || {};
        var vid = currentVariantId();
        var url = (vid && byVariant[vid]) || byVariant['*'] || null;
        if (!url) { log('no mapped image for finish', _finishCode, 'variant', vid); return; }
        imgs.forEach(function(img, i) {
            if (!img.dataset.canadelOrig) img.dataset.canadelOrig = img.src;
            if (i === 0) {                 // swap the hero; thumbnails left as-is for v1
                img.src = url;
                img.srcset = '';
                img.onerror = function() { img.src = img.dataset.canadelOrig; img.onerror = null; };
            }
        });
    }

    function setFinish(code, name) {
        _finishCode = code;
        _finishName = name;
        var selector = getSelector();
        if (selector) {
            var valueEl = selector.querySelector('[data-finish-value]');
            if (valueEl) valueEl.textContent = name;
            selector.querySelectorAll('.canadel-finish-selector__swatch').forEach(function(s) {
                s.classList.toggle('canadel-finish-selector__swatch--selected', s.dataset.finishCode === code);
            });
        }
        ensureFormInput();
        if (_finishInput) _finishInput.value = name;
        swapImage();
    }

    document.addEventListener('change', function(e) {
        var input = e.target;
        if (input.type !== 'radio' || input.name !== 'canadel_finish') return;
        setFinish(input.dataset.finishCode, input.value);
    });

    document.addEventListener('variant:change', function(evt) {
        if (!getSelector()) return;
        if (evt.detail && evt.detail.variant) _variantId = String(evt.detail.variant.id);
        // re-apply current finish to the newly-shown variant image
        setTimeout(swapImage, 150);
    });

    document.addEventListener('DOMContentLoaded', function() {
        var selector = getSelector();
        if (!selector) return;
        _finishCode = selector.dataset.defaultCode || null;
        _finishName = selector.dataset.defaultValue || null;
        ensureFormInput();
        log('init finish=', _finishName, _finishCode);
    });
})();

// =============================================================================
// MULTI-SWATCH ORDERING
// =============================================================================
// Drawer-based multi-swatch selector with tag filtering, fabric detail overlay,
// and 5-swatch limit. Pulls data from Fabric Swatch metaobjects.

var SWATCH_MAX = 5;

// =============================================================================
// LAZY SWATCH DATA (static JSON)
// =============================================================================
// The drawer grid + filter dropdowns + the (i)/order detail map are built
// client-side from assets/swatch-data.json (generated by
// Stickley_import/export-swatch-json.mjs) instead of inline Liquid — so PDP HTML
// stays light and we never hit Liquid's 50-item metaobject-reference cap.
var _swatchJsonPromise = null;  // fetch promise (cached)
var _swatchMap = null;          // normSwatchKey -> swatch obj (ALL, incl. finishes) for the (i) overlay
var _drawerSwatches = null;     // orderable (non-finish) swatches for THIS product, for the grid
var _drawerPopulated = false;

function _escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
}
// Trailing numeric id from either "gid://shopify/Metaobject/123" or a bare "123".
function _gidTail(s) {
    var m = String(s == null ? '' : s).match(/(\d+)\s*$/);
    return m ? m[1] : '';
}
// Append a CDN width param without clobbering an existing ?v= cache-buster.
function _swatchImg(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
}

function loadSwatchData() {
    if (_swatchJsonPromise) return _swatchJsonPromise;
    var drawer = document.getElementById('swatch-drawer');
    var url = drawer && drawer.dataset.swatchDataUrl;
    if (!url) return Promise.resolve(null);
    _swatchJsonPromise = fetch(url)
        .then(function(r) { if (!r.ok) throw new Error('swatch-data ' + r.status); return r.json(); })
        .catch(function(e) { console.error('swatch-data load failed:', e); _swatchJsonPromise = null; return null; });
    return _swatchJsonPromise;
}

// Build _swatchMap (all swatches for the (i) overlay) + _drawerSwatches (orderable,
// for the grid) for THIS product, from the JSON + the drawer's collection GIDs.
function prepareSwatchData(data) {
    if (_swatchMap) return true;
    if (!data || !data.collections) return false;
    _swatchMap = {};
    _drawerSwatches = [];
    var drawer = document.getElementById('swatch-drawer');
    // Liquid emits the numeric metaobject id (.system.id); the JSON has full GIDs
    // (gid://shopify/Metaobject/123). Match on the trailing numeric tail of both.
    var idSet = {};
    ((drawer && drawer.dataset.swatchCollections) || '').split(',').forEach(function(s) {
        var t = _gidTail(s); if (t) idSet[t] = true;
    });
    if (!Object.keys(idSet).length) return true;                  // no linked collections → empty drawer (don't mix vendors)
    var seen = {};
    data.collections.forEach(function(col) {
        if (!idSet[_gidTail(col.id)]) return;                     // only this product's collections
        var isFinish = /finish/i.test(col.name || '');
        (col.swatches || []).forEach(function(sw) {
            swatchKeysFor(sw.name).forEach(function(k) { if (!_swatchMap[k]) _swatchMap[k] = sw; });  // (i) map: all
            if (!isFinish && sw.orderable !== false) {            // grid: orderable, de-duped by fabric number (name when absent)
                var key = (sw.fabricNumber || sw.name || '').toLowerCase();
                if (!seen[key]) { seen[key] = true; _drawerSwatches.push(sw); }
            }
        });
    });
    return true;
}

function ensureSwatchData() {
    if (_swatchMap) return Promise.resolve(true);
    return loadSwatchData().then(prepareSwatchData);
}

// ---- Drawer grid + filter bar builders (replicate the old Liquid markup so the
//      existing filter/count/submit/(i) logic keeps working unchanged) ----
var _swatchInfoSvg = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.2"/><path d="M9 8v5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><circle cx="9" cy="5.5" r="0.75" fill="currentColor"/></svg>';
var _filterChevron = '<svg class="swatch-drawer__filter-chevron" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

function _gridItemHtml(sw, dupNames) {
    var name = sw.name || '';
    var num = sw.fabricNumber || '';
    // Distinct fabrics can share a display name (e.g. two Rowe "Straw"s) — when
    // that happens, surface the fabric number so the tiles are tellable apart.
    var showNum = num && dupNames && dupNames[name.toLowerCase()] > 1;
    var tags = Array.isArray(sw.tags) ? sw.tags.join(',') : (sw.tags || '');
    var preview = sw.image
        ? '<span class="swatch-drawer__swatch-preview" style="background-image: url(\'' + _escHtml(_swatchImg(sw.image, 120)) + '\')"></span>'
        : (sw.color
            ? '<span class="swatch-drawer__swatch-preview swatch-drawer__swatch-preview--color" data-color-name="' + _escHtml((sw.color || '').toLowerCase()) + '"></span>'
            : '<span class="swatch-drawer__swatch-preview"></span>');
    return '<div class="swatch-drawer__option-wrapper" data-swatch-tags="' + _escHtml(tags) +
        '" data-swatch-color="' + _escHtml(sw.color || '') +
        '" data-swatch-fabric-type="' + _escHtml(sw.fabricType || '') +
        '" data-swatch-print="' + _escHtml(sw.print || '') + '">' +
        '<label class="swatch-drawer__option">' +
        '<input type="checkbox" value="' + _escHtml(name) + '" name="swatch-select" data-swatch-name="' + _escHtml(name) + '" data-fabric-number="' + _escHtml(num) + '">' +
        preview +
        '<span class="swatch-drawer__swatch-name">' + _escHtml(name) +
        (showNum ? ' <span class="swatch-drawer__swatch-number">' + _escHtml(num) + '</span>' : '') +
        '<button type="button" class="swatch-drawer__info-btn" data-swatch-info aria-label="Fabric details for ' + _escHtml(name) + '">' + _swatchInfoSvg + '</button>' +
        '</span></label></div>';
}

function _filterGroupHtml(dim, label, valueCounts, withDot) {
    var keys = Object.keys(valueCounts).sort();
    if (!keys.length) return '';
    var opts = keys.map(function(v) {
        var dot = withDot ? '<span class="swatch-drawer__filter-color-dot" data-color-name="' + _escHtml(v.toLowerCase()) + '"></span>' : '';
        return '<label class="swatch-drawer__filter-option"><input type="checkbox" name="filter-' + dim + '" value="' + _escHtml(v) + '" data-filter-input="' + dim + '">' +
            dot + '<span class="swatch-drawer__filter-label">' + _escHtml(v) + '</span>' +
            '<span class="swatch-drawer__filter-count" data-filter-count>' + valueCounts[v] + '</span></label>';
    }).join('');
    return '<div class="swatch-drawer__filter-group" data-filter-group="' + dim + '">' +
        '<button type="button" class="swatch-drawer__filter-btn" data-filter-toggle="' + dim + '">' + label + _filterChevron + '</button>' +
        '<div class="swatch-drawer__filter-dropdown" data-filter-panel="' + dim + '" style="display: none;">' + opts + '</div></div>';
}

function populateDrawer(drawer) {
    if (_drawerPopulated || !_drawerSwatches) return;
    var listEl = drawer.querySelector('[data-swatch-list]');
    var barEl = drawer.querySelector('[data-swatch-filter-bar]');
    if (!listEl) return;

    // Grid — count names first so duplicates get their fabric number shown
    var dupNames = {};
    _drawerSwatches.forEach(function(s) {
        var k = (s.name || '').toLowerCase();
        dupNames[k] = (dupNames[k] || 0) + 1;
    });
    listEl.innerHTML = _drawerSwatches.map(function(s) { return _gridItemHtml(s, dupNames); }).join('') ||
        '<p class="swatch-drawer__loading">No swatches available.</p>';

    // Filters: distinct values + counts
    if (barEl) {
        var color = {}, features = {}, ftype = {}, print = {};
        _drawerSwatches.forEach(function(s) {
            if (s.color) color[s.color] = (color[s.color] || 0) + 1;
            if (s.fabricType) ftype[s.fabricType] = (ftype[s.fabricType] || 0) + 1;
            if (s.print) print[s.print] = (print[s.print] || 0) + 1;
            (Array.isArray(s.tags) ? s.tags : []).forEach(function(t) { if (t) features[t] = (features[t] || 0) + 1; });
        });
        var html = _filterGroupHtml('color', 'Color', color, true) +
            _filterGroupHtml('features', 'Features', features, false) +
            _filterGroupHtml('fabric_type', 'Fabric Type', ftype, false) +
            _filterGroupHtml('print', 'Print', print, false);
        if (html) { barEl.innerHTML = html; barEl.hidden = false; }
    }

    // Apply colour dots from COLOR_HEX_MAP (same as the old inline path)
    drawer.querySelectorAll('[data-color-name]').forEach(function(dot) {
        var hex = COLOR_HEX_MAP[dot.dataset.colorName];
        if (hex) { dot.style.backgroundColor = hex; if (dot.dataset.colorName === 'white' || dot.dataset.colorName === 'ivory') dot.style.border = '1px solid #ccc'; }
    });

    _cachedSwatchInputs = null;  // force re-cache in updateSwatchCount
    _drawerPopulated = true;
}

// On multi-option products the swatch snippet renders once per option, so there
// can be several #swatch-drawer elements sharing the same id (same duplicate-id
// gotcha as #swatch-overlay → _activeSwatchOverlay). openSwatchDrawer moves the
// drawer it opens to <body>, which reorders the DOM and makes
// getElementById('swatch-drawer') return a DIFFERENT (hidden) duplicate
// afterward — so close/submit/position must use the tracked active element.
var _activeSwatchDrawer = null;
function getActiveSwatchDrawer() {
    if (_activeSwatchDrawer && document.contains(_activeSwatchDrawer)) return _activeSwatchDrawer;
    return document.getElementById('swatch-drawer');
}

function openSwatchDrawer() {
    var drawer = document.getElementById('swatch-drawer');
    if (!drawer) return;
    _activeSwatchDrawer = drawer;
    // Move drawer to body to escape any parent stacking contexts (sticky header, transforms)
    if (drawer.parentElement !== document.body) {
        document.body.appendChild(drawer);
    }
    // Lazy-build the grid + filters from the static JSON on first open.
    ensureSwatchData().then(function(ok) {
        if (ok && _drawerSwatches) {
            populateDrawer(drawer);
        } else {
            var loadingEl = drawer.querySelector('[data-swatch-loading]');
            if (loadingEl) loadingEl.textContent = 'Unable to load swatches right now. Please refresh and try again.';
        }
    });
    SWATCH_MAX = parseInt(drawer.dataset.maxSwatches) || 5;
    drawer.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    setTimeout(function() {
        drawer.classList.add('swatch-drawer--open');
    }, 10);
}

function closeSwatchDrawer() {
    var drawer = getActiveSwatchDrawer();
    if (!drawer) return;
    drawer.classList.remove('swatch-drawer--open');
    closeSwatchOverlay();
    setTimeout(function() {
        drawer.style.display = 'none';
        document.body.style.overflow = '';
    }, 300);
}

var _swatchCountRafId = 0;
var _cachedSwatchInputs = null;

function updateSwatchCount() {
    cancelAnimationFrame(_swatchCountRafId);
    _swatchCountRafId = requestAnimationFrame(_updateSwatchCountNow);
}

function _updateSwatchCountNow() {
    if (!_cachedSwatchInputs || !_cachedSwatchInputs.length) {
        _cachedSwatchInputs = document.querySelectorAll('.swatch-drawer__option input');
    }

    var count = 0;
    var uncheckedInputs = [];
    _cachedSwatchInputs.forEach(function(input) {
        if (input.checked) count++;
        else uncheckedInputs.push(input);
    });

    var countEl = document.getElementById('swatch-count');
    var submitBtn = document.getElementById('swatch-submit-btn');

    if (countEl) {
        countEl.textContent = count + ' of ' + SWATCH_MAX + ' swatches selected';
    }
    if (submitBtn) {
        submitBtn.disabled = count === 0;
        if (count === 0) {
            submitBtn.textContent = 'Select swatches to order';
        } else {
            submitBtn.textContent = 'Add ' + count + ' Swatch' + (count !== 1 ? 'es' : '') + ' to Cart';
        }
    }

    // Enforce max limit — disable unchecked boxes when at limit
    uncheckedInputs.forEach(function(input) {
        input.disabled = count >= SWATCH_MAX;
        var wrapper = input.closest('.swatch-drawer__option');
        if (wrapper) {
            wrapper.classList.toggle('swatch-drawer__option--disabled', count >= SWATCH_MAX);
        }
    });

    // Show limit message
    var limitMsg = document.getElementById('swatch-limit-msg');
    if (count >= SWATCH_MAX) {
        if (!limitMsg) {
            limitMsg = document.createElement('p');
            limitMsg.id = 'swatch-limit-msg';
            limitMsg.className = 'swatch-drawer__limit-msg';
            limitMsg.textContent = 'Maximum of ' + SWATCH_MAX + ' swatches reached';
            var countParent = countEl ? countEl.parentElement : null;
            if (countParent) countParent.insertBefore(limitMsg, countEl);
        }
    } else if (limitMsg) {
        limitMsg.remove();
    }
}

// Color category → hex mapping for filter dots and swatch preview fallbacks
var COLOR_HEX_MAP = {
    'white': '#FFFFFF', 'gray': '#808080', 'brown': '#8B6914', 'natural': '#D4BF93',
    'blue': '#005BD3', 'black': '#000000', 'pink': '#D4A0A0', 'multi': '#CCCCCC',
    'green': '#28342C', 'yellow': '#D4B96A', 'orange': '#C4843C', 'red': '#8B3A3A',
    'tan': '#C1BAA8', 'beige': '#EAD8AB', 'ivory': '#FFFFE3'
};

function filterSwatches() {
    // Build filter state once from all checked inputs
    var filters = { color: [], features: [], fabric_type: [], print: [] };
    var filterInputsByDim = { color: [], features: [], fabric_type: [], print: [] };
    document.querySelectorAll('[data-filter-input]').forEach(function(input) {
        var dim = input.dataset.filterInput;
        if (filters[dim]) {
            if (input.checked) filters[dim].push(input.value);
            filterInputsByDim[dim].push(input);
        }
    });

    var wrappers = document.querySelectorAll('.swatch-drawer__option-wrapper');

    // Single pass: compute visibility + cross-filter counts for all dimensions
    var counts = { color: {}, features: {}, fabric_type: {}, print: {} };
    var visibility = new Array(wrappers.length);

    wrappers.forEach(function(wrapper, idx) {
        var swatchColor = (wrapper.dataset.swatchColor || '').trim();
        var swatchTagsRaw = wrapper.dataset.swatchTags || '';
        var swatchTags = swatchTagsRaw ? swatchTagsRaw.split(',').map(function(t) { return t.trim(); }) : [];
        var swatchFT = (wrapper.dataset.swatchFabricType || '').trim();
        var swatchPrint = (wrapper.dataset.swatchPrint || '').trim();

        // Check each dimension independently
        var passesColor = filters.color.length === 0 || filters.color.indexOf(swatchColor) !== -1;

        var passesFeatures = true;
        if (filters.features.length > 0) {
            passesFeatures = false;
            for (var i = 0; i < filters.features.length; i++) {
                if (swatchTags.indexOf(filters.features[i]) !== -1) { passesFeatures = true; break; }
            }
        }

        var passesFabricType = filters.fabric_type.length === 0 || filters.fabric_type.indexOf(swatchFT) !== -1;
        var passesPrint = filters.print.length === 0 || filters.print.indexOf(swatchPrint) !== -1;

        visibility[idx] = passesColor && passesFeatures && passesFabricType && passesPrint;

        // Cross-filter counts: for dimension X, count if wrapper passes all OTHER dimensions
        if (passesFeatures && passesFabricType && passesPrint && swatchColor) {
            counts.color[swatchColor] = (counts.color[swatchColor] || 0) + 1;
        }
        if (passesColor && passesFabricType && passesPrint) {
            for (var j = 0; j < swatchTags.length; j++) {
                if (swatchTags[j]) counts.features[swatchTags[j]] = (counts.features[swatchTags[j]] || 0) + 1;
            }
        }
        if (passesColor && passesFeatures && passesPrint && swatchFT) {
            counts.fabric_type[swatchFT] = (counts.fabric_type[swatchFT] || 0) + 1;
        }
        if (passesColor && passesFeatures && passesFabricType && swatchPrint) {
            counts.print[swatchPrint] = (counts.print[swatchPrint] || 0) + 1;
        }
    });

    // Batch all DOM writes in a single rAF
    requestAnimationFrame(function() {
        // Apply visibility
        wrappers.forEach(function(wrapper, idx) {
            wrapper.style.display = visibility[idx] ? '' : 'none';
        });

        // Update counts on filter inputs
        var dims = ['color', 'features', 'fabric_type', 'print'];
        dims.forEach(function(dim) {
            filterInputsByDim[dim].forEach(function(input) {
                var countEl = input.closest('.swatch-drawer__filter-option').querySelector('[data-filter-count]');
                if (countEl) countEl.textContent = counts[dim][input.value] || 0;
            });
        });

        // Update active state on filter buttons
        document.querySelectorAll('.swatch-drawer__filter-group').forEach(function(group) {
            var dim = group.dataset.filterGroup;
            var btn = group.querySelector('.swatch-drawer__filter-btn');
            if (btn) btn.classList.toggle('swatch-drawer__filter-btn--active', filters[dim] && filters[dim].length > 0);
        });
    });
}

function toggleFilterDropdown(dimension) {
    var targetPanel = document.querySelector('[data-filter-panel="' + dimension + '"]');
    if (!targetPanel) return;

    var isOpen = targetPanel.style.display !== 'none';

    // Close all panels
    document.querySelectorAll('.swatch-drawer__filter-dropdown').forEach(function(panel) {
        panel.style.display = 'none';
    });
    document.querySelectorAll('.swatch-drawer__filter-btn').forEach(function(btn) {
        btn.classList.remove('swatch-drawer__filter-btn--open');
    });

    // Toggle the clicked one
    if (!isOpen) {
        targetPanel.style.display = '';
        var btn = document.querySelector('[data-filter-toggle="' + dimension + '"]');
        if (btn) btn.classList.add('swatch-drawer__filter-btn--open');
    }
}

var CARE_GUIDES = {
    'W': '<strong>Care: Code W (Water-Based)</strong><br>' +
        'Spot-clean with a water-based cleaning agent such as a mild detergent or non-solvent upholstery shampoo. ' +
        'Apply cleaning solution with a soft cloth in a circular motion. Do not over-wet the fabric. ' +
        'Allow to air-dry away from direct heat or sunlight. Vacuum regularly with an upholstery attachment to remove dust and debris.',
    'S': '<strong>Care: Code S (Solvent-Based)</strong><br>' +
        'Spot-clean using a mild, water-free dry-cleaning solvent only. Do not use water-based cleaners as they may cause spotting or shrinkage. ' +
        'Apply solvent with a clean white cloth and blot gently — do not rub. ' +
        'Test in an inconspicuous area first. Ventilate the room when using solvents. Vacuum regularly with an upholstery attachment.',
    'W/S': '<strong>Care: Code W/S (Water or Solvent)</strong><br>' +
        'Spot-clean with either a water-based cleaning agent (mild detergent) or a mild dry-cleaning solvent. ' +
        'When using water-based cleaners, do not over-wet — apply with a soft cloth and blot. ' +
        'When using solvents, ventilate the room and test in a hidden area first. Vacuum regularly with an upholstery attachment.',
    'X': '<strong>Care: Code X (Vacuum Only)</strong><br>' +
        'Clean this fabric only by vacuuming or light brushing to remove dust and debris. ' +
        'Do not use any water-based or solvent-based cleaning agents, as they may cause permanent damage, staining, or shrinkage. ' +
        'For stubborn stains, consult a professional upholstery cleaner.',
    'W-Performance': '<strong>Care: Performance Fabric</strong><br>' +
        'This high-performance fabric is engineered for easy cleaning and everyday durability. ' +
        'Most spills can be wiped away with a damp cloth and mild soap. For tougher stains, use a mixture of mild detergent and warm water — ' +
        'apply with a soft cloth and blot until the stain lifts. Machine-washable covers (if removable) can be washed on a gentle cycle with cold water. ' +
        'Avoid bleach and harsh chemicals. Vacuum regularly to prevent dirt buildup.',
    'Leather': '<strong>Care: Leather</strong><br>' +
        'Dust regularly with a dry, soft cloth. For routine cleaning, wipe with a lightly damp cloth and allow to air-dry. ' +
        'Apply a leather conditioner every 6–12 months to maintain suppleness and prevent cracking. ' +
        'Avoid placing in direct sunlight or near heat sources, which can cause fading and drying. ' +
        'Blot spills immediately — never rub. Do not use saddle soap, oils, furniture polish, or abrasive cleaners.'
};

// The request-swatch snippet is rendered once per matching variant option,
// so on multi-axis products (e.g. Stickley Cornell Chair has Cover + Finish)
// the page ends up with several #swatch-overlay elements sharing the same ID.
// We lock onto a single active overlay on first open and reuse it every time —
// otherwise document.getElementById() returns a *different* duplicate after
// the first one is moved to <body>, and close handlers operate on the wrong
// (still-hidden) element.
var _activeSwatchOverlay = null;
function getActiveSwatchOverlay() {
    if (_activeSwatchOverlay && document.contains(_activeSwatchOverlay)) {
        return _activeSwatchOverlay;
    }
    _activeSwatchOverlay = document.getElementById('swatch-overlay');
    return _activeSwatchOverlay;
}

function openSwatchOverlay(data) {
    var overlay = getActiveSwatchOverlay();
    if (!overlay) return;
    // Guard against rapid clicks — skip if overlay is already open/opening
    if (overlay.classList.contains('swatch-drawer__overlay--open')) return;

    // Look up fields *within* the active overlay so we don't accidentally
    // hit a sibling duplicate's #swatch-overlay-name etc.
    var imageEl = overlay.querySelector('#swatch-overlay-image');
    var nameEl = overlay.querySelector('#swatch-overlay-name');
    var manufacturerEl = overlay.querySelector('#swatch-overlay-manufacturer');
    var materialEl = overlay.querySelector('#swatch-overlay-material');
    var careEl = overlay.querySelector('#swatch-overlay-care');
    var descriptionEl = overlay.querySelector('#swatch-overlay-description');
    var tagsEl = overlay.querySelector('#swatch-overlay-tags');

    if (nameEl) nameEl.textContent = data.name || '';

    if (imageEl) {
        if (data.image) {
            imageEl.innerHTML = '<img src="' + _escHtml(_swatchImg(data.image, 600)) + '" alt="' + _escHtml(data.name || '') + '">';
        } else if (data.color) {
            imageEl.innerHTML = '<div class="swatch-drawer__overlay-color-block" style="background-color: ' + data.color + '"></div>';
        } else {
            imageEl.innerHTML = '';
        }
    }

    if (tagsEl) {
        // JSON gives an array; the legacy inline path gave a comma string — handle both.
        var tagArr = Array.isArray(data.tags)
            ? data.tags.slice()
            : (data.tags ? String(data.tags).split(',') : []);
        tagArr = tagArr.map(function(t) { return String(t).trim(); }).filter(Boolean);
        if (tagArr.length > 0) {
            tagsEl.innerHTML = tagArr.map(function(t) {
                return '<span class="swatch-drawer__overlay-tag">' + _escHtml(t) + '</span>';
            }).join('');
            tagsEl.style.display = '';
        } else {
            tagsEl.innerHTML = '';
            tagsEl.style.display = 'none';
        }
    }

    if (manufacturerEl) {
        manufacturerEl.innerHTML = data.manufacturer ? '<strong>Brand</strong><span>' + data.manufacturer + '</span>' : '';
        manufacturerEl.style.display = data.manufacturer ? '' : 'none';
    }
    if (materialEl) {
        materialEl.innerHTML = data.material ? '<strong>Content</strong><span>' + data.material + '</span>' : '';
        materialEl.style.display = data.material ? '' : 'none';
    }
    if (careEl) {
        var careContent = CARE_GUIDES[data.care] || (data.care ? data.care.replace(/\n/g, '<br>') : '');
        careEl.innerHTML = careContent ? '<strong>Care</strong><span>' + careContent + '</span>' : '';
        careEl.style.display = careContent ? '' : 'none';
    }
    if (descriptionEl) {
        // Build with safe DOM nodes (description is admin-authored prose; avoid
        // innerHTML). Newlines → <br>.
        descriptionEl.replaceChildren();
        if (data.description && typeof data.description === 'string') {
            var dStrong = document.createElement('strong');
            dStrong.textContent = 'About';
            descriptionEl.appendChild(dStrong);
            var dSpan = document.createElement('span');
            data.description.split('\n').forEach(function (line, idx) {
                if (idx > 0) dSpan.appendChild(document.createElement('br'));
                if (line) dSpan.appendChild(document.createTextNode(line));
            });
            descriptionEl.appendChild(dSpan);
            descriptionEl.style.display = '';
        } else {
            descriptionEl.style.display = 'none';
        }
    }

    // "Order a free sample" — stash the swatch name on the overlay and reveal
    // the button only for orderable swatches (fabrics/leathers, not finishes).
    overlay.dataset.swatchName = data.name || '';
    overlay.dataset.fabricNumber = data.fabricNumber || '';
    var orderBtn = overlay.querySelector('[data-order-swatch-sample]');
    var orderMsg = overlay.querySelector('[data-order-swatch-msg]');
    if (orderMsg) orderMsg.textContent = '';
    if (orderBtn) {
        if (data.orderable && data.name) {
            orderBtn.style.display = '';
            orderBtn.disabled = false;
            orderBtn.textContent = 'Order a free sample';
        } else {
            orderBtn.style.display = 'none';
        }
    }

    // Move overlay to body to escape stacking contexts
    if (overlay.parentElement !== document.body) {
        document.body.appendChild(overlay);
    }

    // Position: if drawer is open, sit adjacent; otherwise standalone on right edge
    var drawer = getActiveSwatchDrawer();
    var drawerIsOpen = drawer && drawer.classList.contains('swatch-drawer--open');
    overlay.classList.toggle('swatch-drawer__overlay--standalone', !drawerIsOpen);

    // Add backdrop for standalone mode
    if (!drawerIsOpen) {
        var backdrop = document.getElementById('swatch-overlay-backdrop');
        if (!backdrop) {
            backdrop = document.createElement('div');
            backdrop.id = 'swatch-overlay-backdrop';
            backdrop.className = 'swatch-overlay-backdrop';
            backdrop.addEventListener('click', function() { closeSwatchOverlay(); });
            document.body.appendChild(backdrop);
        }
        backdrop.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }

    overlay.style.display = 'flex';
    setTimeout(function() {
        overlay.classList.add('swatch-drawer__overlay--open');
    }, 10);
}

function closeSwatchOverlay() {
    var overlay = _activeSwatchOverlay || document.querySelector('.swatch-drawer__overlay--open') || document.getElementById('swatch-overlay');
    if (!overlay) return;
    var wasStandalone = overlay.classList.contains('swatch-drawer__overlay--standalone');
    overlay.classList.remove('swatch-drawer__overlay--open');
    setTimeout(function() {
        overlay.style.display = 'none';
        overlay.classList.remove('swatch-drawer__overlay--standalone');
        // If standalone (no drawer), restore body scroll and remove backdrop
        if (wasStandalone) {
            document.body.style.overflow = '';
            var backdrop = document.getElementById('swatch-overlay-backdrop');
            if (backdrop) backdrop.style.display = 'none';
        }
    }, 300);
}

// Find a drawer swatch by its fabric number — the unambiguous key. Names can
// repeat across distinct fabrics, so number-based resolution comes first
// everywhere the grid is involved.
function _findSwatchByNumber(num) {
    if (!num || !_drawerSwatches) return null;
    for (var i = 0; i < _drawerSwatches.length; i++) {
        if ((_drawerSwatches[i].fabricNumber || '') === num) return _drawerSwatches[i];
    }
    return null;
}

// Vendor + fabric number line-item properties for a swatch, so staff can place
// the vendor sample order straight from the Shopify order screen. Resolves by
// fabric number when the caller has one (grid tiles carry it), else by name in
// the lazy-loaded JSON (_swatchMap — first-wins on duplicate names); vendor
// falls back to the product's vendor when the metaobject has no manufacturer.
function swatchOrderProps(name, fabricNumber) {
    var props = {};
    var sw = _findSwatchByNumber(fabricNumber);
    if (!sw && _swatchMap) {
        var keys = swatchKeysFor(name);
        for (var i = 0; i < keys.length && !sw; i++) sw = _swatchMap[keys[i]];
    }
    var drawer = getActiveSwatchDrawer();
    var vendor = (sw && sw.manufacturer) || (drawer && drawer.dataset.productVendor) || '';
    if (vendor) props['Vendor'] = vendor;
    if (sw && sw.fabricNumber) props['Fabric #'] = sw.fabricNumber;
    return props;
}

function submitSwatches() {
    var checked = document.querySelectorAll('.swatch-drawer__option input:checked');
    if (checked.length === 0) return;

    var productTitle = document.querySelector('[data-swatch-product-title]');
    var productName = productTitle ? productTitle.textContent.trim() : '';
    var swatchVariantId = getActiveSwatchDrawer()?.dataset.swatchVariantId;
    if (!swatchVariantId) return;

    var items = [];
    checked.forEach(function(input) {
        var props = { 'Color': input.value, 'Product': productName };
        Object.assign(props, swatchOrderProps(input.value, input.dataset.fabricNumber));
        items.push({
            id: parseInt(swatchVariantId),
            quantity: 1,
            properties: props
        });
    });

    var submitBtn = document.getElementById('swatch-submit-btn');
    if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
    })
    .then(function(response) {
        if (!response.ok) throw new Error('Failed to add swatches');
        return response.json();
    })
    .then(function() {
        fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
                var cartCounts = document.querySelectorAll('.header__cart-count, [data-cart-count]');
                cartCounts.forEach(function(el) {
                    el.textContent = cart.item_count;
                });
            });

        checked.forEach(function(input) { input.checked = false; });
        updateSwatchCount();
        closeSwatchDrawer();
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })
    .catch(function(err) {
        console.error('Swatch add error:', err);
        if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Error — try again';
        }
    });
}

// Order a single swatch directly from the (i) detail overlay — solves "I want a
// sample of the fabric I'm looking at" without hunting the drawer. Reuses the
// same Fabric Swatch product + Color/Product line-item properties as the drawer.
function orderSwatchSample(overlay) {
    var btn = overlay.querySelector('[data-order-swatch-sample]');
    var msg = overlay.querySelector('[data-order-swatch-msg]');
    var swatchName = overlay.dataset.swatchName;
    if (!swatchName) return;
    var drawer = document.getElementById('swatch-drawer');
    var swatchVariantId = drawer && drawer.dataset.swatchVariantId;
    if (!swatchVariantId) return;
    var titleEl = document.querySelector('[data-swatch-product-title]');
    var productTitle = titleEl ? titleEl.textContent.trim() : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var props = { 'Color': swatchName, 'Product': productTitle };
    Object.assign(props, swatchOrderProps(swatchName, overlay.dataset.fabricNumber));
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(swatchVariantId), quantity: 1, properties: props }] })
    })
    .then(function(r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function() {
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            document.querySelectorAll('.header__cart-count, [data-cart-count]').forEach(function(el) { el.textContent = cart.item_count; });
        });
        if (btn) btn.textContent = 'Added ✓';
        if (msg) msg.textContent = 'Free sample added to your cart.';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })
    .catch(function() {
        if (btn) { btn.disabled = false; btn.textContent = 'Order a free sample'; }
        if (msg) msg.textContent = 'Could not add — please try again.';
    });
}

// Initialize swatch drawer triggers
document.addEventListener('DOMContentLoaded', function() {
    // De-duplicate shared singletons. The swatch snippet renders once per
    // swatch-rendering option, so multi-option products (e.g. Fabric + Finish)
    // emit several #swatch-drawer / #swatch-overlay elements sharing the same
    // id. They're identical, but the duplicate ids break every
    // getElementById-/document-wide lookup (filters, swatch count, submit
    // enable, close all targeted the wrong hidden copy). Keep the first of each
    // and drop the rest so every lookup resolves to the one live element.
    document.querySelectorAll('#swatch-drawer').forEach(function(el, i) { if (i > 0) el.remove(); });
    document.querySelectorAll('#swatch-overlay').forEach(function(el, i) { if (i > 0) el.remove(); });

    // Open drawer
    document.addEventListener('click', function(e) {
        if (e.target.closest('[data-open-swatch-drawer]')) {
            e.preventDefault();
            // Pre-check the currently selected variant's swatch
            var colorFieldset = document.querySelector('fieldset.variant-picker__option[data-option-name="color"]');
            if (colorFieldset) {
                var selectedInput = colorFieldset.querySelector('.variant-picker__option-values input:checked');
                if (selectedInput) {
                    var drawerInput = document.querySelector('.swatch-drawer__option input[value="' + selectedInput.value + '"]');
                    if (drawerInput && !drawerInput.checked) {
                        drawerInput.checked = true;
                    }
                }
            }
            updateSwatchCount();
            openSwatchDrawer();
        }
    });

    // Close drawer
    document.addEventListener('click', function(e) {
        if (e.target.closest('[data-close-swatch-drawer]')) {
            closeSwatchDrawer();
        }
    });

    // Backdrop click closes drawer. Delegated, because there may be several
    // duplicate #swatch-drawer elements and the active one is moved to <body>
    // on open — a listener bound to one element at init would miss it.
    document.addEventListener('click', function(e) {
        if (e.target.id === 'swatch-drawer' && e.target.classList.contains('swatch-drawer')) {
            closeSwatchDrawer();
        }
    });

    // Checkbox change
    document.addEventListener('change', function(e) {
        if (e.target.closest('.swatch-drawer__option input')) {
            updateSwatchCount();
        }
    });

    // Filter dropdown toggles
    document.addEventListener('click', function(e) {
        var toggleBtn = e.target.closest('[data-filter-toggle]');
        if (toggleBtn) {
            e.stopPropagation();
            toggleFilterDropdown(toggleBtn.dataset.filterToggle);
            return;
        }
        // Close dropdowns when clicking outside filter bar
        if (!e.target.closest('.swatch-drawer__filter-bar')) {
            document.querySelectorAll('.swatch-drawer__filter-dropdown').forEach(function(panel) {
                panel.style.display = 'none';
            });
            document.querySelectorAll('.swatch-drawer__filter-btn').forEach(function(btn) {
                btn.classList.remove('swatch-drawer__filter-btn--open');
            });
        }
    });

    // Filter checkbox changes
    document.addEventListener('change', function(e) {
        if (e.target.closest('[data-filter-input]')) {
            filterSwatches();
        }
    });

    // Apply color dots from COLOR_HEX_MAP
    document.querySelectorAll('[data-color-name]').forEach(function(dot) {
        var colorName = dot.dataset.colorName;
        var hex = COLOR_HEX_MAP[colorName];
        if (hex) {
            dot.style.backgroundColor = hex;
            if (colorName === 'white' || colorName === 'ivory') {
                dot.style.border = '1px solid #ccc';
            }
        }
    });

    // Fabric info button → open overlay
    document.addEventListener('click', function(e) {
        var infoBtn = e.target.closest('[data-swatch-info]');
        if (infoBtn) {
            e.preventDefault();
            e.stopPropagation();
            // Grid items are JS-built; resolve detail data by fabric number
            // first (unambiguous when two fabrics share a name), then by name
            // from _swatchMap (the lazy JSON), not an inline <script>.
            var wrapper = infoBtn.closest('.swatch-drawer__option-wrapper');
            if (!wrapper) return;
            var nameInput = wrapper.querySelector('input[data-swatch-name]');
            var name = nameInput ? nameInput.getAttribute('data-swatch-name') : '';
            var data = _findSwatchByNumber(nameInput ? nameInput.getAttribute('data-fabric-number') : '') ||
                (name && _swatchMap ? _swatchMap[normSwatchKey(name)] : null);
            if (data) openSwatchOverlay(data);
        }
    });

    // Close overlay — X button, click outside the panel, or ESC key.
    // We look at _activeSwatchOverlay (the element open/close functions are
    // bound to) rather than document.getElementById, which returns the wrong
    // duplicate on pages where the snippet renders more than once.
    document.addEventListener('click', function(e) {
        // X button — always closes, regardless of which overlay duplicate
        // received the click.
        if (e.target.closest('[data-close-swatch-overlay]')) {
            closeSwatchOverlay();
            return;
        }

        var overlay = _activeSwatchOverlay;
        if (!overlay || !overlay.classList.contains('swatch-drawer__overlay--open')) return;

        // Outside-click: only in standalone mode (no drawer behind), and only
        // if the click did not land on the overlay panel itself or on a
        // swatch-info trigger (which would re-open it).
        if (!overlay.classList.contains('swatch-drawer__overlay--standalone')) return;
        if (overlay.contains(e.target)) return;
        if (e.target.closest('[data-swatch-info], .variant-picker__info-btn')) return;
        closeSwatchOverlay();
    });

    document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        if (_activeSwatchOverlay && _activeSwatchOverlay.classList.contains('swatch-drawer__overlay--open')) {
            closeSwatchOverlay();
        }
    });

    // Submit
    document.addEventListener('click', function(e) {
        if (e.target.closest('#swatch-submit-btn')) {
            e.preventDefault();
            submitSwatches();
        }
    });

    // Order a single sample from the (i) detail overlay
    document.addEventListener('click', function(e) {
        var orderBtn = e.target.closest('[data-order-swatch-sample]');
        if (orderBtn) {
            e.preventDefault();
            var ov = orderBtn.closest('.swatch-drawer__overlay');
            if (ov) orderSwatchSample(ov);
        }
    });

    // Add (i) info icon next to variant picker selected value text
    initVariantPickerInfoIcon();
});

// =============================================================================
// VARIANT PICKER (i) INFO ICON
// =============================================================================
// Adds a single (i) button inline with the selected variant value text
// (e.g. "Fabric: Antiqued Moss Velvet (i)"). Clicking opens the fabric
// detail overlay as a standalone panel (no drawer needed).

// Normalise a swatch name / option value the SAME way variant-picker.liquid
// matches swatch images: lowercase, strip separators, drop the "fabric"/
// "leather" qualifier word. Plus a "drop leading wood-species token" alias so
// option value "032 Onondaga" matches swatch "Oak 032 Onondaga", and "4887-91"
// matches "4887-91 Fabric". Keeps the picker (i) in lockstep with the images.
var SWATCH_SPECIES = { oak:1, cherry:1, mahogany:1, walnut:1, maple:1, pine:1, hickory:1, birch:1, ash:1 };
function normSwatchKey(s) {
    return (s || '').toLowerCase().replace(/[\s\-/().,&]/g, '').replace(/leather/g, '').replace(/fabric/g, '');
}
function swatchKeysFor(name) {
    var keys = [normSwatchKey(name)];
    var toks = (name || '').trim().split(/\s+/);
    if (toks.length >= 3 && SWATCH_SPECIES[toks[0].toLowerCase()]) {
        keys.push(normSwatchKey(toks.slice(1).join(' ')));
    }
    return keys.filter(Boolean);
}

// The swatch detail map is built from the lazy-loaded JSON (prepareSwatchData),
// not inline scripts. Kept as a function for call-site compatibility.
function buildSwatchDataMap() {
    return _swatchMap || {};
}

// Make the variant-picker swatch chips cap-free. Liquid's own swatch-image
// lookup (variant-picker.liquid) only reads the first 50 swatches per
// fabric_collection, so when a product links one large collection any offered
// value past #50 renders without its image:
//   - 'swatch' selector style  → a `.color-swatch` with a gradient fallback
//   - 'variant_image' style     → a `.block-swatch` *text* label (the blank
//                                 thumbnail fallback in option-value.liquid)
// We fill/promote both from the lazy-loaded _swatchMap (no cap). SSR still covers
// the first 50; this only touches the rest. Guarded on the swatch actually having
// an image in the JSON, so genuinely image-less values (e.g. the "Dark Maple"
// finish, which isn't in swatch-data.json) are left as their text chip — correct.
// Degrades gracefully (selectable chip, no thumbnail) if the JSON fails to load.
function _pickerChipValue(label) {
    var input = label.previousElementSibling;
    if (!input || input.tagName !== 'INPUT') {
        var forId = label.getAttribute('for');
        input = forId ? document.getElementById(forId) : null;
    }
    return input ? input.value : (label.getAttribute('data-tooltip') || label.textContent.trim());
}
function fillPickerSwatchImages() {
    var map = _swatchMap || {};
    if (!Object.keys(map).length) return;
    // Mirror the theme's swatch shape: option-value.liquid adds `rounded-full` to
    // color-swatches when settings.round_color_swatches is on. Detect it from an
    // existing SSR color-swatch so promoted chips match (round vs square).
    var rounded = !!document.querySelector('.variant-picker__option-values label.color-swatch.rounded-full');
    document.querySelectorAll('.variant-picker__option-values label.color-swatch, .variant-picker__option-values label.block-swatch').forEach(function(label) {
        if ((label.style.getPropertyValue('--swatch-background') || '').indexOf('url(') !== -1) return; // already imaged
        var val = _pickerChipValue(label);
        var sw = val ? map[normSwatchKey(val)] : null;
        if (!sw || !sw.image) return; // image-less value (e.g. "Dark Maple") → leave its text/gradient chip
        if (label.classList.contains('block-swatch')) {
            // Promote the text fallback to a real swatch chip, replicating
            // option-value.liquid's color-swatch class set (color-swatch [rounded-full] [border]).
            var cls = 'color-swatch';
            if (rounded) cls += ' rounded-full';
            var vlc = val.toLowerCase();
            if (vlc === 'white' || vlc === 'ivory') cls += ' border';
            label.className = cls;
            label.setAttribute('data-tooltip', val);
            label.innerHTML = '<span class="sr-only">' + _escHtml(val) + '</span>';
        }
        label.style.setProperty('--swatch-background', "url('" + _swatchImg(sw.image, 72) + "')");
    });
}

function initVariantPickerInfoIcon() {
    // Inject the (i) + fill cap-overflow swatch images once the JSON is loaded
    // (the picker chips are server-rendered, so the buy path never waits on this).
    ensureSwatchData().then(function() {
        var swatchDataMap = _swatchMap || {};
        if (Object.keys(swatchDataMap).length === 0) return;
        fillPickerSwatchImages();
        document.querySelectorAll('fieldset.variant-picker__option').forEach(function(fieldset) {
            var valueEl = fieldset.querySelector('variant-option-value');
            if (!valueEl) return;
            if (fieldset.querySelector('.variant-picker__info-btn')) return;     // already injected
            if (!swatchDataMap[normSwatchKey(valueEl.textContent)]) return;
            var infoBtn = document.createElement('button');
            infoBtn.type = 'button';
            infoBtn.className = 'variant-picker__info-btn';
            infoBtn.setAttribute('aria-label', 'Fabric details');
            infoBtn.innerHTML = _swatchInfoSvg;
            valueEl.after(infoBtn);
            infoBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                var data = (_swatchMap || {})[normSwatchKey(valueEl.textContent)];
                if (data) openSwatchOverlay(data);
            });
        });
    });

    // Toggle (i) visibility when the selected value changes.
    document.addEventListener('variant:change', function() {
        setTimeout(function() {
            var map = _swatchMap || {};
            document.querySelectorAll('.variant-picker__info-btn').forEach(function(btn) {
                var valueEl = btn.previousElementSibling;
                if (!valueEl || valueEl.tagName.toLowerCase() !== 'variant-option-value') return;
                btn.style.display = map[normSwatchKey(valueEl.textContent)] ? '' : 'none';
            });
        }, 50);
    });
}

// =============================================================================
// RESTWELL NAV ENHANCEMENT (Phase D)
// Transforms "Restwell" text to "Rest<em>well</em>" with serif styling
// =============================================================================
(function restwellNavEnhancement() {
    document.addEventListener('DOMContentLoaded', function() {
        var restwellNavItems = document.querySelectorAll('.header__primary-nav-item[data-title="Restwell"]');
        restwellNavItems.forEach(function(item) {
            var linkText = item.querySelector('a.block, details > summary');
            if (!linkText) return;
            var text = linkText.textContent.trim().toLowerCase();
            if (text === 'restwell') {
                linkText.innerHTML = '<span class="restwell-nav-text">Rest<em>well</em></span>';
            }
        });
    });
})();

// =============================================================================
// SAFETY NET: ProductGalleryNavigation getAttribute error
// =============================================================================
// When barcode-based filtering hides gallery media, the IntersectionObserver
// in theme.js can fire for hidden elements. The navigation then fails to find
// a matching item, causing "Cannot read properties of undefined (reading
// 'getAttribute')" at theme.js:3533. This patches the error by wrapping
// the observer callback.

(function patchGalleryNavigation() {
    // Wait for custom elements to be defined
    if (typeof customElements === 'undefined') return;

    // Try to patch after the element is defined
    function patch() {
        var navProto = customElements.get('product-gallery-navigation');
        if (!navProto) return false;

        // Wrap the connectedCallback to intercept IntersectionObserver creation
        var origConnected = navProto.prototype.connectedCallback;
        if (!origConnected || navProto.prototype._patchedGalleryNav) return false;
        navProto.prototype._patchedGalleryNav = true;

        // Instead of patching the prototype, add a global error handler for this specific error
        return true;
    }

    // Simple approach: catch the error globally for this specific case
    window.addEventListener('error', function(e) {
        if (e && e.message && e.message.indexOf("Cannot read properties of undefined (reading 'getAttribute')") !== -1 &&
            e.filename && e.filename.indexOf('theme.js') !== -1) {
            e.preventDefault();
            // Silently suppress — this is a known issue from hidden gallery media
            return true;
        }
    });
})();

// =============================================================================
// RESTWELL NAV LINK ENHANCEMENT
// =============================================================================
// Splits "Restwell" text in header nav into "Rest" + "well" (italic)
// for branded typography styling

(function restwellNavEnhancement() {
    document.addEventListener('DOMContentLoaded', function() {
        var restwellNavItems = document.querySelectorAll('.header__primary-nav-item[data-title="Restwell"]');

        restwellNavItems.forEach(function(item) {
            // Find the link text element (could be <a> or <summary>)
            var linkText = item.querySelector('a.block, details > summary');
            if (!linkText) return;

            var text = linkText.textContent.trim().toLowerCase();
            if (text === 'restwell') {
                linkText.innerHTML = '<span class="restwell-nav-text">Rest<em>well</em></span>';
            }
        });
    });
})();

// =============================================================================
// ANALYTICS: product_added_to_cart + checkout_started
// =============================================================================
// Fires the Meta Pixel (hardcoded fbq) and Shopify Web Pixel customer events
// consumed by app pixels (Klaviyo, Meta Pixel app). The theme's own event bus
// uses "variant:add" for successful cart adds and a [name="checkout"] submit
// button for checkout — neither natively fires the Shopify analytics events.

(function() {
    var currency = function() {
        return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    };

    var toDollars = function(cents) {
        return (cents / 100).toFixed(2);
    };

    var toGid = function(resource, id) {
        return 'gid://shopify/' + resource + '/' + id;
    };

    var buildMerchandise = function(item, curr) {
        return {
            id: toGid('ProductVariant', item.variant_id),
            title: item.variant_title || '',
            price: { amount: toDollars(item.price), currencyCode: curr },
            image: item.featured_image
                ? { src: item.featured_image.url, alt: item.featured_image.alt || item.title }
                : null,
            product: {
                id: toGid('Product', item.product_id),
                title: item.title,
                vendor: item.vendor || '',
                type: item.product_type || '',
                url: item.url || ('/products/' + item.handle)
            }
        };
    };

    // product_added_to_cart — fires after every successful add-to-cart
    document.addEventListener('variant:add', function(evt) {
        var items = evt.detail && evt.detail.items;
        if (!items || !items.length) return;

        var item = items[0];
        var curr = currency();
        var value = parseFloat(toDollars(item.price));

        // Meta Pixel
        if (typeof fbq === 'function') {
            fbq('track', 'AddToCart', {
                value: value,
                currency: curr,
                content_ids: [String(item.variant_id)],
                content_type: 'product_variant',
                contents: [{ id: String(item.variant_id), quantity: item.quantity, item_price: value }]
            });
        }

        // Shopify Web Pixel (Klaviyo cart-abandonment, Meta Pixel app, etc.)
        var pub = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
        if (typeof pub === 'function') {
            pub('product_added_to_cart', {
                cartLine: {
                    cost: { totalAmount: { amount: toDollars(item.price * item.quantity), currencyCode: curr } },
                    merchandise: buildMerchandise(item, curr),
                    quantity: item.quantity
                }
            });
        }
    });

    // checkout_started — fires when the customer clicks any checkout submit button
    document.addEventListener('click', function(evt) {
        var btn = evt.target.closest('[name="checkout"]');
        if (!btn) return;

        var curr = currency();

        // Meta Pixel — fire immediately, don't block on fetch
        if (typeof fbq === 'function') {
            fbq('track', 'InitiateCheckout');
        }

        // Shopify Web Pixel — needs cart lines; fetch is fast (same-origin)
        var pub = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
        if (typeof pub === 'function') {
            fetch('/cart.js')
                .then(function(r) { return r.json(); })
                .then(function(cart) {
                    pub('checkout_started', {
                        cart: {
                            cost: {
                                totalAmount: { amount: toDollars(cart.total_price), currencyCode: curr }
                            },
                            lines: cart.items.map(function(item) {
                                return {
                                    cost: { totalAmount: { amount: toDollars(item.line_price), currencyCode: curr } },
                                    merchandise: buildMerchandise(item, curr),
                                    quantity: item.quantity
                                };
                            })
                        }
                    });
                });
        }
    });
}());

// =============================================================================
// ANALYTICS: HOME SECTION VIEWS + CLICKS
// =============================================================================
// Pushes GA4 view_promotion / select_promotion onto the GTM dataLayer (container
// GTM-5SCF9VMK, already in theme.liquid), one pair per home section, so a
// click-through rate per section is computable in GA4's Promotions report.
// Section identity comes from data-hm-section (= the section key in
// templates/index.json) rather than CSS classes: home-tile-grid renders twice
// with identical markup (Shop by Room / Brands), and the product + article rails
// loop native objects that have no block ids. Clicks are delegated off document
// because the theme editor and AJAX section swaps replace these nodes wholesale.

(function homeSectionAnalytics() {
    'use strict';

    // Never log the merchant's own clicks while they edit in the customizer.
    if (window.Shopify && window.Shopify.designMode) return;

    var SEEN_RATIO = 0.5;       // half the section on screen...
    var SEEN_MS = 1000;         // ...held this long before it counts as seen
    var CLICK_DEDUPE_MS = 700;  // ignore a repeated click on the same element
    var CLICKABLE = 'a[href], button[type="submit"]';

    // These sections are reused off the home page (page.current-in-store-sale.json
    // renders home-tile-grid and home-showrooms), so the promotion id is scoped by
    // page — otherwise the sale page would report itself as "home_".
    var PAGE = location.pathname === '/'
        ? 'home'
        : location.pathname.replace(/^\/|\/$/g, '').replace(/[^a-z0-9]+/gi, '_').toLowerCase() || 'home';

    // First match wins. Every lookup is scoped inside a [data-hm-section] root,
    // so the class names shared across sections (.hm-btn, .hm-caps-link) are
    // only ever resolved after the more specific ones have had their chance.
    var KINDS = [
        ['.hm-hotspot', 'hotspot'],
        ['.hm-room-item', 'room_item'],
        ['.hm-product-card', 'product_card'],
        ['.hm-feature-card', 'product_card'],
        ['.hm-journal-card', 'article_card'],
        ['.hm-project-card', 'project_card'],
        ['.hm-clearance-card', 'clearance_card'],
        ['.hm-tiles__grid a.hm-media', 'tile'],
        ['.hm-bar__primary', 'sticky_bar_primary'],
        ['.hm-bar__secondary', 'sticky_bar_secondary'],
        ['.hm-promo__all', 'promo_all'],
        ['.hm-under-link', 'promo_lane_link'],
        ['.hm-trade__signin', 'text_link'],
        ['.hm-caps-link', 'header_link'],
        ['a[href^="tel:"]', 'call'],
        ['.hm-visits a[target="_blank"]', 'directions'],
        ['button[type="submit"]', 'form_submit'],
        ['.hm-btn', 'cta']
    ];

    var LABEL_SELECTORS = [
        '.hm-tile-label__name',
        '.hm-product-card__title',
        '.hm-room-item__title',
        '.hm-journal-card__title',
        '.hm-project-card__title',
        '.hm-clearance-card__title'
    ].join(', ');

    // GTM may be blocked, stripped by an ad blocker, or simply absent: push into
    // an inert array rather than throwing inside a click handler.
    function push(payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null }); // clear the previous object
            window.dataLayer.push(payload);
        } catch (_) {}
    }

    function clean(str) {
        return (str || '').replace(/\s+/g, ' ').trim().slice(0, 100);
    }

    function kindOf(el) {
        for (var i = 0; i < KINDS.length; i++) {
            if (el.matches(KINDS[i][0])) return KINDS[i][1];
        }
        return 'link';
    }

    function labelOf(el) {
        if (el.dataset.hmItem) return clean(el.dataset.hmItem);
        if (el.getAttribute('aria-label')) return clean(el.getAttribute('aria-label'));
        var titleEl = el.querySelector(LABEL_SELECTORS);
        if (titleEl) return clean(titleEl.textContent);
        return clean(el.textContent);
    }

    function sectionOf(root) {
        // In a JSON template Shopify renders section.id as
        // "template--<templateId>__<key>". The template id changes if the
        // template is ever recreated, which would silently start a new
        // promotion in GA4 — so keep only the key ("hero", "rooms", ...).
        var raw = root.dataset.hmSection || 'unknown';
        return {
            id: raw.split('__').pop(),
            label: clean(root.dataset.hmLabel) || root.dataset.hmSection || 'unknown',
            position: parseInt(root.dataset.hmPosition, 10) || 0
        };
    }

    // Real product ids where the Liquid could supply them; a prefixed synthetic
    // id otherwise, so these pseudo-items stay filterable in GA4's Items report.
    function itemFor(el, sec, slot, index) {
        var item = {
            item_id: el.dataset.hmItemId || (PAGE + '_' + sec.id + '_' + slot),
            item_name: labelOf(el),
            item_category: PAGE + '_' + sec.id,
            index: index
        };
        if (el.dataset.hmItemBrand) item.item_brand = clean(el.dataset.hmItemBrand);
        if (el.dataset.hmItemPrice) {
            var price = parseFloat(el.dataset.hmItemPrice);
            if (!isNaN(price)) item.price = price;
        }
        return item;
    }

    // ---------------------------------------------------------------- clicks
    var lastEl = null;
    var lastAt = 0;

    document.addEventListener('click', function(evt) {
        var el = evt.target.closest(CLICKABLE);
        if (!el) return;

        var root = el.closest('[data-hm-section]');
        if (!root) return;

        var now = Date.now();
        if (el === lastEl && now - lastAt < CLICK_DEDUPE_MS) return;
        lastEl = el;
        lastAt = now;

        var sec = sectionOf(root);
        var kind = kindOf(el);
        // Recomputed per click rather than cached: an AJAX section swap would
        // invalidate a cached list, and this only runs on a real click.
        var index = Array.prototype.indexOf.call(root.querySelectorAll(CLICKABLE), el) + 1;
        var slot = kind + '_' + index;

        push({
            event: 'select_promotion',
            ecommerce: {
                promotion_id: PAGE + '_' + sec.id,
                promotion_name: sec.label,
                creative_name: labelOf(el),
                creative_slot: slot,
                items: [itemFor(el, sec, slot, index)]
            },
            hm_section: sec.id,
            hm_section_position: sec.position,
            hm_element: kind,
            hm_link_url: el.getAttribute('href') || ''
        });
    });

    // ----------------------------------------------------------------- views
    function fireView(root) {
        if (root.dataset.hmSeen === '1') return;
        root.dataset.hmSeen = '1';

        var sec = sectionOf(root);
        push({
            event: 'view_promotion',
            ecommerce: {
                promotion_id: PAGE + '_' + sec.id,
                promotion_name: sec.label,
                creative_name: 'section',
                creative_slot: 'position_' + sec.position,
                items: [{
                    item_id: PAGE + '_' + sec.id,
                    item_name: sec.label,
                    item_category: PAGE + '_' + sec.id,
                    index: sec.position
                }]
            },
            hm_section: sec.id,
            hm_section_position: sec.position
        });
    }

    function init() {
        var roots = document.querySelectorAll('[data-hm-section]');
        if (!roots.length) return; // one query is the whole cost on every other page

        Array.prototype.forEach.call(roots, function(root, i) {
            root.dataset.hmPosition = i + 1;
        });

        if (!('IntersectionObserver' in window)) return; // clicks still work

        var timers = new WeakMap();

        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var root = entry.target;
                // The hero and shop-the-room are taller than a phone viewport and
                // would never reach 50% of themselves — so "half the section, OR
                // half the screen filled by it" counts as seen.
                var seen = entry.isIntersecting && (
                    entry.intersectionRatio >= SEEN_RATIO ||
                    entry.intersectionRect.height >= window.innerHeight * SEEN_RATIO
                );

                if (!seen) {
                    clearTimeout(timers.get(root));
                    timers.delete(root);
                    return;
                }
                if (timers.has(root)) return;

                timers.set(root, setTimeout(function() {
                    timers.delete(root);
                    if (document.visibilityState !== 'visible') return; // background tab
                    fireView(root);
                    observer.unobserve(root); // once per pageview
                }, SEEN_MS));
            });
        }, { threshold: [0, SEEN_RATIO] });

        Array.prototype.forEach.call(roots, function(root) { observer.observe(root); });
    }

    document.addEventListener('DOMContentLoaded', init);
}());

// =============================================================================
// RESTWELL / NATUREPEDIC MATTRESS PDP
// EOS firmness-split selector + "Complete Your Sleep System" bundle add-to-cart
// =============================================================================
(function restwellMattressPDP() {
    function money(cents) {
        return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    // ---- EOS firmness / split-config selector --------------------------------
    // product-info renders TWICE (mobile + desktop), so this markup is duplicated.
    // We therefore (a) drive selection from shared JS state + an is-selected class
    // instead of id/:checked (duplicate ids break <label for>), and (b) inject ONE
    // set of hidden properties[...] inputs into the product form so firmness
    // submits exactly once (mirrors the stressless-finish-selector approach).
    function initEos() {
        var roots = document.querySelectorAll('[data-eos-firmness]');
        if (!roots.length) return;
        var def = roots[0].dataset.default || '';
        var state = { left: def, right: def, split: false };

        var form = document.querySelector('form[is="product-form"]') || document.querySelector('form[action*="/cart/add"]');
        var injected = {};
        function ensureInputs() {
            if (!form) return;
            [['Left Firmness', 'left'], ['Right Firmness', 'right'], ['Configuration', 'config']].forEach(function(pair) {
                if (injected[pair[1]] && injected[pair[1]].isConnected) return;
                var el = form.querySelector('input[data-eos-injected="' + pair[1] + '"]');
                if (!el) {
                    el = document.createElement('input');
                    el.type = 'hidden';
                    el.name = 'properties[' + pair[0] + ']';
                    el.setAttribute('data-eos-injected', pair[1]);
                    form.appendChild(el);
                }
                injected[pair[1]] = el;
            });
        }

        function apply() {
            ensureInputs();
            var rightVal = state.split ? state.right : state.left;
            if (injected.left) injected.left.value = state.left;
            if (injected.right) injected.right.value = rightVal;
            if (injected.config) injected.config.value = state.split ? 'Split' : 'Same on both sides';

            roots.forEach(function(root) {
                var toggle = root.querySelector('[data-eos-split-toggle]');
                if (toggle) toggle.checked = state.split;
                var rightSide = root.querySelector('[data-eos-side="right"]');
                if (rightSide) rightSide.hidden = !state.split;
                var sides = root.querySelector('[data-eos-sides]');
                if (sides) sides.classList.toggle('rw-eos__sides--split', state.split);
                var leftLegend = root.querySelector('[data-eos-left-legend]');
                if (leftLegend) leftLegend.textContent = state.split ? 'Left side firmness' : 'Firmness';
                root.querySelectorAll('input[name="eos_left"]').forEach(function(i) {
                    var on = i.value === state.left; i.checked = on;
                    var o = i.closest('.rw-eos__opt'); if (o) o.classList.toggle('is-selected', on);
                });
                root.querySelectorAll('input[name="eos_right"]').forEach(function(i) {
                    var on = i.value === rightVal; i.checked = on;
                    var o = i.closest('.rw-eos__opt'); if (o) o.classList.toggle('is-selected', on);
                });
            });
        }

        // Split configuration is only offered on Queen and larger — hide the
        // toggle (and force a single firmness) on Twin / Twin XL / Full.
        var SPLIT_SIZES = { "Queen": 1, "King": 1, "Cal King": 1 };
        var sizeMap = {};
        var szEl = document.querySelector('[data-eos-sizes]');
        if (szEl) { try { sizeMap = JSON.parse(szEl.textContent); } catch (e) {} }

        function refreshSplitAvailability() {
            var size = sizeMap[mattressVariantId()];
            var allowed = !size || SPLIT_SIZES[size]; // unknown size → leave enabled
            if (!allowed) state.split = false;
            roots.forEach(function(root) {
                var toggle = root.querySelector('[data-eos-split-toggle]');
                var row = toggle ? toggle.closest('.rw-eos__split') : null;
                if (row) row.style.display = allowed ? '' : 'none';
            });
            apply();
        }

        document.addEventListener('change', function(e) {
            var t = e.target;
            if (!t) return;
            if (t.name === 'eos_left') state.left = t.value;
            else if (t.name === 'eos_right') state.right = t.value;
            else if (t.hasAttribute && t.hasAttribute('data-eos-split-toggle')) state.split = !!t.checked;
            else return;
            apply();
        });
        document.addEventListener('variant:change', refreshSplitAvailability);

        refreshSplitAvailability();
    }

    // Collect EOS line-item properties from the single injected form input set
    function eosProperties() {
        var props = {};
        document.querySelectorAll('[data-eos-injected]').forEach(function(input) {
            var m = (input.name || '').match(/^properties\[(.+)\]$/);
            if (m && input.value) props[m[1]] = input.value;
        });
        return props;
    }

    // ---- "Complete Your Sleep System" bundle ---------------------------------
    function mattressVariantId() {
        var el = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        return el ? parseInt(el.value, 10) : NaN;
    }

    function initSleepSystem(root) {
        var checks = root.querySelectorAll('[data-addon-check]');
        var totalWrap = root.querySelector('[data-addon-total]');
        var totalVal = root.querySelector('[data-addon-total-value]');
        var btn = root.querySelector('[data-add-sleep-system]');
        var msg = root.querySelector('[data-sleep-system-msg]');

        function rowQty(check) {
            var row = check.closest('[data-addon]');
            var q = row ? row.querySelector('[data-addon-qty]') : null;
            var n = q ? parseInt(q.value, 10) : 1;
            return (isNaN(n) || n < 1) ? 1 : n;
        }

        function updateTotal() {
            var cents = 0;
            var any = false;
            checks.forEach(function(c) {
                if (c.checked) {
                    any = true;
                    cents += (parseInt(c.dataset.price, 10) || 0) * rowQty(c);
                }
            });
            if (totalVal) totalVal.textContent = money(cents);
            if (totalWrap) totalWrap.hidden = !any;
        }

        function showMsg(text) {
            if (!msg) return;
            msg.textContent = text;
            msg.hidden = !text;
        }

        function add() {
            var mattressId = mattressVariantId();
            if (!mattressId) { showMsg('Please choose a size first.'); return; }

            var items = [{ id: mattressId, quantity: 1, properties: eosProperties() }];
            checks.forEach(function(c) {
                if (c.checked) {
                    items.push({
                        id: parseInt(c.dataset.variantId, 10),
                        quantity: rowQty(c),
                        properties: { _bundle: 'Restwell Sleep System' }
                    });
                }
            });

            showMsg('');
            btn.disabled = true;
            var label = btn.textContent;
            btn.textContent = 'Adding…';

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items })
            })
            .then(function(r) {
                if (!r.ok) return r.json().then(function(e) { throw new Error(e.description || 'Could not add to cart'); });
                return r.json();
            })
            .then(function() {
                return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
                document.querySelectorAll('.header__cart-count, [data-cart-count]').forEach(function(el) {
                    el.textContent = cart.item_count;
                });
                checks.forEach(function(c) { c.checked = false; });
                updateTotal();
                btn.disabled = false;
                btn.textContent = label;
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                var drawer = document.querySelector('cart-drawer');
                if (drawer && typeof drawer.show === 'function') drawer.show();
            })
            .catch(function(err) {
                btn.disabled = false;
                btn.textContent = label;
                showMsg((err && err.message) ? err.message : 'Something went wrong — please try again.');
            });
        }

        // ---- Size-matching: resolve each add-on to the variant whose Size
        //      matches the mattress's selected size (e.g. Queen → Queen
        //      foundation), preferring a "Standard" profile. Falls back to the
        //      add-on's default variant when there's no size match.
        var mSizes = {};
        var msEl = root.querySelector('[data-mattress-sizes]');
        if (msEl) { try { mSizes = JSON.parse(msEl.textContent); } catch (e) {} }

        function resolveSizes() {
            var msize = mSizes[mattressVariantId()] || null;
            checks.forEach(function(c) {
                var card = c.closest('[data-addon]');
                var matchedEl = card ? card.querySelector('[data-addon-matched]') : null;
                var vEl = card ? card.querySelector('[data-addon-variants]') : null;
                if (matchedEl) matchedEl.textContent = '';
                if (!msize || !vEl) return;
                var variants;
                try { variants = JSON.parse(vEl.textContent); } catch (e) { return; }
                // Secondary option chosen on the card (e.g. Profile: Standard/Low Profile)
                var optSel = card.querySelector('[data-addon-option]');
                var optName = optSel ? optSel.getAttribute('data-addon-option') : null;
                var optVal = optSel ? optSel.value : null;
                var cands = variants.filter(function(v) {
                    if (!v.available || v.size !== msize) return false;
                    if (optName && v.opts && v.opts[optName] !== optVal) return false;
                    return true;
                });
                if (!cands.length) return; // no match → keep default variant
                // No selector but multiple (e.g. Profile) → prefer Standard
                var pick = optName ? cands[0] : (cands.filter(function(v) { return /standard/i.test(v.title); })[0] || cands[0]);
                c.dataset.variantId = pick.id;
                c.dataset.price = pick.price;
                var priceEl = card.querySelector('.rw-addon__price');
                if (priceEl) priceEl.textContent = money(pick.price);
                if (matchedEl) matchedEl.textContent = pick.size ? ('Size-matched to your ' + pick.size) : '';
            });
            updateTotal();
        }

        root.addEventListener('change', resolveSizes);
        if (btn) btn.addEventListener('click', add);
        document.addEventListener('variant:change', resolveSizes);
        resolveSizes();
        updateTotal();
    }

    // ---- Comfort Levels overlay (the firmness (i) icon) ----------------------
    function initComfortGuide() {
        var overlays = document.querySelectorAll('[data-comfort-overlay]');
        if (!overlays.length) return;
        // Rendered once per product-info copy (mobile + desktop) — keep one,
        // move it to <body>, drop the rest.
        var overlay = overlays[0];
        for (var i = 1; i < overlays.length; i++) {
            if (overlays[i].parentNode) overlays[i].parentNode.removeChild(overlays[i]);
        }
        if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

        function open() {
            overlay.hidden = false;
            requestAnimationFrame(function() { overlay.classList.add('is-open'); });
            document.body.style.overflow = 'hidden';
        }
        function close() {
            overlay.classList.remove('is-open');
            document.body.style.overflow = '';
            setTimeout(function() { overlay.hidden = true; }, 250);
        }

        document.addEventListener('click', function(e) {
            if (!e.target || !e.target.closest) return;
            if (e.target.closest('[data-eos-info]')) { e.preventDefault(); open(); }
            else if (e.target.closest('[data-comfort-close]')) { close(); }
        });
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && !overlay.hidden) close();
        });
    }

    // ---- Restwell EOS video lightbox -----------------------------------------
    // Opens the full EOS video in a modal so users can watch it with controls
    // (the hero plays muted/looped behind the green overlay). One modal per
    // section instance; closes on backdrop click, the close button, or ESC.
    function initEosVideoLightbox() {
        var modals = document.querySelectorAll('[data-rw-eos-modal]');
        if (!modals.length) return;

        modals.forEach(function(modal) {
            var video = modal.querySelector('video');
            var section = modal.previousElementSibling && modal.previousElementSibling.classList.contains('rw-eos-video')
                ? modal.previousElementSibling
                : modal.closest('.shopify-section') || document;
            var openBtn = section.querySelector('[data-rw-eos-open]');
            var closeBtn = modal.querySelector('[data-rw-eos-close]');
            if (!openBtn) return;

            function open() {
                modal.hidden = false;
                modal.setAttribute('aria-hidden', 'false');
                document.body.classList.add('rw-eos-video-open');
                if (video) {
                    try { video.currentTime = 0; } catch (_) {}
                    var p = video.play();
                    if (p && p.catch) p.catch(function() {});
                }
            }
            function close() {
                if (video) { try { video.pause(); } catch (_) {} }
                modal.hidden = true;
                modal.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('rw-eos-video-open');
            }

            openBtn.addEventListener('click', open);
            if (closeBtn) closeBtn.addEventListener('click', close);
            modal.addEventListener('click', function(e) {
                // Click on backdrop (the modal itself, not the frame) closes.
                if (e.target === modal) close();
            });
            document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape' && !modal.hidden) close();
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        initEos();
        document.querySelectorAll('[data-sleep-system]').forEach(initSleepSystem);
        initComfortGuide();
        initEosVideoLightbox();
    });
}());


/* =========================================================================
   COLLECTION FACET PILLS — single-open + outside-click/Escape close
   (markup: snippets/facets-pills.liquid; delegated so it survives the
   facet:update AJAX section swaps in theme.js)
   ========================================================================= */
(function () {
    'use strict';

    document.addEventListener('toggle', function (evt) {
        var pill = evt.target;
        if (!pill.matches || !pill.matches('.facets-pill') || !pill.open) return;
        pill.closest('[data-facets-pills]').querySelectorAll('.facets-pill[open]').forEach(function (other) {
            if (other !== pill) other.removeAttribute('open');
        });
    }, true);

    document.addEventListener('click', function (evt) {
        var open = document.querySelectorAll('[data-facets-pills] .facets-pill[open]');
        if (!open.length) return;
        open.forEach(function (pill) {
            if (!pill.contains(evt.target)) pill.removeAttribute('open');
        });
    });

    document.addEventListener('keydown', function (evt) {
        if (evt.key !== 'Escape') return;
        document.querySelectorAll('[data-facets-pills] .facets-pill[open]').forEach(function (pill) {
            pill.removeAttribute('open');
        });
    });
}());

/* =========================================================================
   FACET PILLS — suppress theme.js's post-update scroll for pill-originated
   filter changes. theme.js's facet:update listener always smooth-scrolls
   `.collection` into view after swapping the section, which yanks the page
   down when a shopper checks a value in an open pill panel. We no-op
   scrollIntoView on the freshly-swapped .collection node ONLY when the
   update came from the pill bar — pagination and chip clicks keep the
   scroll (there it's helpful).
   ========================================================================= */
(function () {
    'use strict';

    document.addEventListener('facet:update', function (evt) {
        var origin = evt.target;
        if (!origin || !origin.closest || !origin.closest('[data-facets-pills]')) return;
        var section = origin.closest('.shopify-section');
        if (!section) return;

        var observer = new MutationObserver(function () {
            var collection = section.querySelector('.collection');
            if (collection && !Object.prototype.hasOwnProperty.call(collection, 'scrollIntoView')) {
                collection.scrollIntoView = function () {};
                observer.disconnect();
            }
        });
        observer.observe(section, { childList: true, subtree: true });
        setTimeout(function () { observer.disconnect(); }, 2000);
    }, true);
}());
